import { useQuery } from 'react-query'
import { useChosenCompany } from '../../../../context/UserProvider'
import { fetchFuelExpenseReport } from '../../../../api/api'
import { useParams, useSearchParams } from 'react-router-dom'
import FuelReportExpenseDetailsTable from '../components/FuelTables/FuelReportExpenseDetailsTable'
import { ExcelExportButton } from '../components/ExcelExporter'
import { excelFuelReportExpenseDetailsColumns } from '../components/FuelTables/excelUtils'

const FuelReportExpenseDetails = () => {
  const { date, account } = useParams()
  const [searchParams] = useSearchParams()
  const regNo = searchParams.get('regNo') || ''
  const company = useChosenCompany()
  const companyId = company?.id

  const [year, month] = date ? date.split('-') : ['', '']

  const { data: response, isLoading } = useQuery(
    ['fuelReportExpenseDetails', year, month, account],
    () => fetchFuelExpenseReport({ year, month, account }),
    { enabled: !!companyId },
  )

  //@ts-expect-error axios type issue
  const data = (Array.isArray(response) ? response : response?.data || []) as FuelReportExpenseDetails[]

  const columns = excelFuelReportExpenseDetailsColumns()
  const config = {
    columns,
    filename: `Drivstoffrapport_${regNo}_${year}_${month}.xlsx`,
    sheetName: `Drivstoff_${regNo}_${year}_${month}`,
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col md:flex-row md:items-center gap-2 md:justify-between">
        <div className="flex flex-row justify-between ">
          <div className="flex flex-col md:items-center md:flex-row gap-2">
            <span className="text-xl font-medium text-primaryText">Drivstoffrapport</span>
            <span className=" hidden md:block text-lg text-secondaryText">/</span>
            <span className="text-lg text-secondaryText">
              {year}-{month}
            </span>
          </div>
          <div className="md:hidden">
            <ExcelExportButton data={data} config={config} />
          </div>
        </div>
        <div className="hidden md:block">
          <ExcelExportButton data={data} config={config} />
        </div>
      </div>
      <FuelReportExpenseDetailsTable isLoading={isLoading} data={data} />
    </div>
  )
}

export default FuelReportExpenseDetails
